<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page1"></a><em>Appetizers</em></h1>
<p class="centering"><img alt="" src="OEBPS/images/9781449400217_1.jpg"/><br/><br/></p>
<p class="centering"><img alt="" src="OEBPS/images/9781449400217_1-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400217_epub_p01_r1.vue?449b7410